export default function AboutSection() {
  return (
    <section id="about" className="py-16 md:py-24 bg-background-100">
      <div className="w-full max-w-[1024px] mx-auto px-4 md:px-6">
        <div className="rounded-2xl bg-background-200/60 border border-background-300/40 overflow-hidden">
          <div className="flex flex-col lg:flex-row">
            <div className="flex-1 p-8 md:p-12 lg:p-14">
              <span className="inline-block px-3 py-1 text-xs font-medium text-accent-300 bg-accent-500/10 rounded-full mb-4">
                关于我们
              </span>
              <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-50 mb-5">
                关于8848影院
              </h2>
              <div className="space-y-4 text-sm md:text-base text-foreground-400 leading-relaxed">
                <p>
                  8848影院是一个致力于为全球华语观众提供<strong className="text-foreground-200">免费高清电影在线观看</strong>服务的综合观影平台。
                  我们相信，好的电影应该被更多人看到，不应该被付费墙和会员制所阻隔。
                </p>
                <p>
                  从经典老片到最新大片，从<strong className="text-foreground-200">动作片的凌厉拳脚</strong>到<strong className="text-foreground-200">喜剧片的捧腹笑料</strong>，
                  8848影院电影大全涵盖了你能想到的几乎所有电影类型与题材。我们的编辑团队每日精心筛选和更新片库，
                  确保每一位访问者都能在这里找到属于自己的光影世界。
                </p>
                <p>
                  即点即播、无需注册、无需付费——这是8848影院始终如一的承诺。
                  无论你是在通勤路上用手机，还是在家中客厅用电脑，都能享受到流畅稳定的高清观影体验。
                </p>
              </div>
              <div className="flex flex-wrap gap-4 mt-6">
                <div className="flex items-center gap-2 text-sm text-foreground-500">
                  <i className="ri-checkbox-circle-fill text-accent-400"></i>
                  <span>片源丰富，20000+高清电影</span>
                </div>
                <div className="flex items-center gap-2 text-sm text-foreground-500">
                  <i className="ri-checkbox-circle-fill text-accent-400"></i>
                  <span>每日更新，紧跟全球节奏</span>
                </div>
                <div className="flex items-center gap-2 text-sm text-foreground-500">
                  <i className="ri-checkbox-circle-fill text-accent-400"></i>
                  <span>全端适配，随时随地观影</span>
                </div>
                <div className="flex items-center gap-2 text-sm text-foreground-500">
                  <i className="ri-checkbox-circle-fill text-accent-400"></i>
                  <span>完全免费，无需注册付费</span>
                </div>
              </div>
            </div>
            <div className="lg:w-[380px] xl:w-[440px] min-h-[240px] lg:min-h-full bg-background-300/40 relative overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20cozy%20home%20cinema%20setup%20with%20large%20screen%20displaying%20movie%2C%20dim%20ambient%20golden%20lighting%2C%20comfortable%20living%20room%20atmosphere%2C%20cinematic%20evening%20vibe%2C%20professional%20interior%20photography%20with%20soft%20shadows%20and%20warm%20tones&width=880&height=800&seq=about-cinema&orientation=portrait"
                alt="8848影院观影体验"
                className="w-full h-full object-cover object-top"
                onError={(e) => { (e.target as HTMLElement).parentElement!.style.display = 'none'; }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}